import { useState, useEffect } from 'react';
import { SMARTeRollUp } from '@amzn/merp-core/models';
import { rollUpService } from '../services';

export function useSmartERollUps() {
    const [loading, updateLoading] = useState(false);
    const [rollUps, updateRollUps] = useState<SMARTeRollUp[]>([]);

    useEffect(() => {
        async function fetchRollUps() {
            updateLoading(true);

            const response = await rollUpService.getSMARTe();

            updateRollUps(response.succeeded ? response.result! : []);
            updateLoading(false);
        }

        fetchRollUps();
    }, [updateRollUps, updateLoading]);

    return { rollUps, loading };
}
